import React from "react";
import HintTip from "../common/HintTip";

const gold = "#E8C547";
const idle = "#C9B896";
const strokeW = 2;

function glyphColor(active) {
  return active ? gold : idle;
}

export function GlyphTask({ size = 24, active }) {
  const c = glyphColor(active);
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <polygon points="12,2 22,8 22,16 12,22 2,16 2,8" fill={active ? "rgba(232,197,71,0.2)" : "rgba(0,0,0,0.3)"} stroke={c} strokeWidth={strokeW} />
      <circle cx="12" cy="12" r="3" fill={active ? gold : "none"} stroke={c} strokeWidth="1.5" />
    </svg>
  );
}

export function GlyphEvent({ size = 24, active }) {
  const c = glyphColor(active);
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <circle cx="12" cy="12" r="9" fill="none" stroke={c} strokeWidth={strokeW} />
      <circle cx="12" cy="12" r="3.5" fill={active ? "rgba(232,197,71,0.25)" : "none"} stroke={c} strokeWidth="1.5" />
    </svg>
  );
}

export function GlyphFocus({ size = 24, active }) {
  const c = glyphColor(active);
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <path d="M12 2 L14 9 L22 10 L16 15 L18 22 L12 18 L6 22 L8 15 L2 10 L10 9 Z" fill={active ? "rgba(232,197,71,0.15)" : "none"} stroke={c} strokeWidth={strokeW} />
    </svg>
  );
}

export function GlyphNote({ size = 24, active }) {
  const c = glyphColor(active);
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <rect x="4" y="4" width="16" height="16" rx="1" fill={active ? "rgba(232,197,71,0.1)" : "rgba(0,0,0,0.2)"} stroke={c} strokeWidth={strokeW} />
      <line x1="8" y1="9" x2="16" y2="9" stroke={c} strokeWidth="1.5" />
      <line x1="8" y1="13" x2="14" y2="13" stroke={c} strokeWidth="1.5" />
    </svg>
  );
}

export function GlyphMigrate({ size = 22, active }) {
  const c = glyphColor(active ?? true);
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      <path d="M5 12 H17 M13 8 L17 12 L13 16" fill="none" stroke={c} strokeWidth={strokeW} strokeLinecap="square" />
      <line x1="3" y1="4" x2="3" y2="20" stroke={c} strokeWidth="1.5" />
    </svg>
  );
}

export const GLYPH_TYPES = [
  { type: "task", Glyph: GlyphTask, label: "Tarea", hint: "Algo que tenés que hacer" },
  { type: "event", Glyph: GlyphEvent, label: "Evento", hint: "Cita con hora o lugar" },
  { type: "focus", Glyph: GlyphFocus, label: "Urgente", hint: "No olvidar hoy" },
  { type: "note", Glyph: GlyphNote, label: "Nota", hint: "Pensamiento suelto en el diario" },
];

export function SymbolStrip({ active, onPick }) {
  return (
    <div className="symbol-strip">
      {GLYPH_TYPES.map(({ type, Glyph, label, hint }) => (
        <HintTip key={type} label={label} hint={hint} block>
          <button
            type="button"
            aria-label={`${label}: ${hint}`}
            aria-pressed={active === type}
            onClick={() => onPick(active === type ? null : type)}
            className={`symbol-btn${active === type ? " symbol-btn-active" : ""}`}
          >
            <Glyph active={active === type} />
          </button>
        </HintTip>
      ))}
    </div>
  );
}

export function EntryIcon({ type, size = 20 }) {
  const map = { task: GlyphTask, event: GlyphEvent, focus: GlyphFocus, note: GlyphNote, migrated: GlyphMigrate };
  const G = map[type] || GlyphNote;
  return <G size={size} active />;
}
